/**
 * Único propietario del historial del navegador.
 *
 * Copiado de Recuperos (`navigation/historial.ts`) porque resuelve bien el
 * problema y no tiene nada específico de aquel dominio. La razón de que exista
 * un solo propietario: con un `pushState` y un listener de `popstate` por
 * vista, cada ruta nueva añade un par que puede desincronizarse.
 *
 * No importa React: puede ejercitarse con `node --test` sin navegador.
 */

export interface Ubicacion {
  pathname: string
  search: string
  /** Estado asociado a la entrada del historial (de dónde se abrió algo). */
  state: unknown
}

const suscriptores = new Set<() => void>()

function leer(): Ubicacion {
  return {
    pathname: window.location.pathname,
    search: window.location.search,
    state: window.history.state,
  }
}

// La instantánea se cachea porque `useSyncExternalStore` exige identidad
// estable entre renders: devolver un objeto nuevo cada vez provoca un bucle.
let instantanea = leer()

function emitir(): void {
  instantanea = leer()
  for (const avisar of suscriptores) avisar()
}

window.addEventListener('popstate', emitir)

export function suscribirUbicacion(avisar: () => void): () => void {
  suscriptores.add(avisar)
  return () => {
    suscriptores.delete(avisar)
  }
}

export function ubicacionActual(): Ubicacion {
  return instantanea
}

export interface OpcionesNavegacion {
  state?: unknown
  reemplazar?: boolean
}

export function navegarA(ruta: string, { state = null, reemplazar = false }: OpcionesNavegacion = {}): void {
  if (reemplazar) window.history.replaceState(state, '', ruta)
  else window.history.pushState(state, '', ruta)
  emitir()
  // Al cambiar de vista se vuelve arriba: si no, una tabla larga deja al
  // usuario a mitad de la pantalla siguiente.
  window.scrollTo({ top: 0 })
}

export function volverAtras(): void {
  window.history.back()
}
